// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"ae93a880","507":"2a65aca9","540":"9c236735","553":"7b0ca92d","589":"5cb00bfe","633":"bc0fd45f","668":"ae5c9f64","767":"5b390619","803":"26c5fe55","825":"41b14bf5","917":"7c2da340","984":"3c3c9b3f","988":"c8c6c9a7"}[chunkId] + ".chunk.js";
};